module.exports = {"id":"204308","name":"Hendrik Van Crombrugge","rating":"72","photo":"./data/images/photos/0/204308.png","club":{"name":"KAS Eupen","logo":"./data/images/clubs/KASEupen.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HendrikVanCrombrugge0.json
// module id = 1724
// module chunks = 0